import {
  OPTIMISATION_THUMBS_INTROS_FINALISATION_TABLES_INITIAL_STATE,
  initialState,
} from "@/models/options";

const v18 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        optimisationThumbsTable: {
          ...OPTIMISATION_THUMBS_INTROS_FINALISATION_TABLES_INITIAL_STATE,
        },
        optimisationIntrosTable: {
          ...OPTIMISATION_THUMBS_INTROS_FINALISATION_TABLES_INITIAL_STATE,
        },
        optimisationFinalisationTable: {
          ...OPTIMISATION_THUMBS_INTROS_FINALISATION_TABLES_INITIAL_STATE,
        },
        optimisationSequenceTable: {
          ...OPTIMISATION_THUMBS_INTROS_FINALISATION_TABLES_INITIAL_STATE,
        },
        optimisationTipsTable: {
          ...initialState.tableViews.optimisationTipsTable,
        },
      },
    },
  };
};

export default v18;
